<template>
  <div v-if="author" class="flex items-center gap-2">
    <div class="relative h-5 w-5 rounded-full overflow-hidden bg-black">

      <NuxtPicture v-if="author?.attributes.thumbnail.data?.attributes.hash || author?.attributes.image.data?.attributes.hash"
                    loading="eager"
                    preload
                    :src="author?.attributes.thumbnail.data?.attributes.hash ?? author?.attributes.image.data.attributes.hash"
                    :imgAttrs="{
                      class:'absolute inset-0 object-cover w-full',
                      
                  }"
      />
      <div v-if="!author?.attributes.thumbnail.data?.attributes.hash && !author?.attributes.image.data?.attributes.hash" class="absolute inset-0 w-full h-full flex items-center justify-center">
        <div class="w-3 h-3">
        <svg class="w-full h-full" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.7619 31.9999C16.7619 41.2572 9.25732 48.7618 0 48.7618L6.66077e-07 63.9998C17.6563 63.9998 31.9727 49.7002 31.9999 32.0503C32.027 49.7003 46.3434 64 63.9998 64L63.9998 48.7619C54.7424 48.7619 47.2379 41.2574 47.2379 32.0001L16.7619 31.9999Z" fill="white"/>
          <path d="M48.7618 32C48.7618 22.7427 41.2572 15.2382 31.9999 15.2382C22.7426 15.2382 15.2381 22.7426 15.2381 31.9999L6.97341e-05 31.9999C6.89616e-05 14.3269 14.3269 7.72514e-07 32 0C49.673 3.50524e-05 63.9998 14.327 63.9998 32H48.7618Z" fill="white"/>
        </svg>
        </div>
      </div>
    </div>
    <a v-if="author.attributes.url" :href="getAuthorUrl(author.attributes.url)" class="author-link">
      <h5>{{ author.attributes.name }}</h5>
    </a>
    <h5 v-else>{{ author.attributes.name }}</h5>
  </div>
</template>

<style scoped>
  .author-link:hover {
    text-decoration: underline;
  }
</style>



<script setup lang="ts">
  const props = defineProps({
    author: {
      type: Object
    }
  });

  function getAuthorUrl(url: any) {
    if (url.startsWith('http') || url.startsWith('www') || url.startsWith('/')) {
      return url;
    }
    return `/${url}`;
  }
</script>
